import { useRef } from 'react';
import { sfx as soundManager } from '../utils/SoundManager';
import { useStore } from '../store/useStore';

type SoundKey = 'jump' | 'attack' | 'hit' | 'step' | 'click'; // Add other keys as needed

export const useAudio = () => {
    const { audioEnabled } = useStore();

    const playSfx = (key: string, volume = 1.0) => {
        if (!audioEnabled) return;
        // Map keys to SoundManager types if needed
        // SoundManager accepts: 'jump' | 'attack' | 'hit' | 'step'
        if (['jump', 'attack', 'hit', 'step'].includes(key)) {
            soundManager.play(key as any);
        }
    };

    const playBgm = (key: string) => {
        // Placeholder as SoundManager doesn't support BGM yet or we don't have synth BGM
        // console.log(`Playing BGM: ${key}`);
    };

    return { playSfx, playBgm };
};
